// Vendor
import { EventEmitter } from '@angular/core';
// Constants
import { HISTORICAL_DATA_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { VALID_FUND_CHART_DATE_ZOOM_OPTIONS } from 'ChartApp/ts/features/fundamental-chart/constants';
// Interfaces / types / enums
import { ChartDateZoom } from 'ChartApp/ts/enums/chart-common.enum';
// Services
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
// Components
import { FeatureNeededComponent } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.component';
import * as i0 from "@angular/core";
import * as i1 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i4 from "../../../../../../../../entitlements/static/entitlements/ts/features/feature-needed/feature-needed.component";
const _c0 = ["featureNeededModal"];
const _c1 = a0 => ({ "current": a0 });
const _c2 = a0 => ({ "text-gray-60": a0 });
function FundChartDateZoomComponent_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 2)(1, "a", 3);
    i0.ɵɵlistener("click", function FundChartDateZoomComponent_li_1_Template_a_click_1_listener($event) { const zoomOption_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.select($event, zoomOption_r2)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const zoomOption_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("chart-control-item ", ctx_r2.customCssClasses.zoomOption, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c1, zoomOption_r2.value === ctx_r2.zoom));
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("chart-control-link ", ctx_r2.customCssClasses.zoomOptionLink, "");
    i0.ɵɵproperty("disabled", !zoomOption_r2.enabled)("ngClass", i0.ɵɵpureFunction1(12, _c2, !zoomOption_r2.enabled));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", zoomOption_r2.label, " ");
} }
export class FundChartDateZoomComponent {
    constructor(featureService) {
        this.featureService = featureService;
        this.customCssClasses = {};
        this.zoomOptions = VALID_FUND_CHART_DATE_ZOOM_OPTIONS;
        this.zoom = ChartDateZoom.CHART_ZOOM_ONE_YEAR;
        this.selectZoomOptionHandler = new EventEmitter();
        this.userHasHistoricalDataFeature = this.featureService.userHasFeatures([HISTORICAL_DATA_FEATURE]);
    }
    ngOnInit() {
        this.zoomOptions = this.createZoomOptions();
    }
    createZoomOptions() {
        return this.zoomOptions.map((option) => {
            const newOption = { ...option };
            // disable historical data options if the user is missing the required feature
            newOption.enabled =
                ![ChartDateZoom.CHART_ZOOM_TEN_YEAR, ChartDateZoom.CHART_ZOOM_MAX].includes(option.value) || this.userHasHistoricalDataFeature;
            return newOption;
        });
    }
    select(event, zoomOption) {
        event.preventDefault();
        if (!zoomOption.enabled) {
            this.featureNeededModal.openModal(HISTORICAL_DATA_FEATURE);
            return;
        }
        this.selectZoomOptionHandler.emit(zoomOption);
    }
}
FundChartDateZoomComponent.ɵfac = function FundChartDateZoomComponent_Factory(t) { return new (t || FundChartDateZoomComponent)(i0.ɵɵdirectiveInject(i1.FeatureService)); };
FundChartDateZoomComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FundChartDateZoomComponent, selectors: [["ycn-fund-chart-date-zoom"]], viewQuery: function FundChartDateZoomComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.featureNeededModal = _t.first);
    } }, inputs: { customCssClasses: "customCssClasses", zoomOptions: "zoomOptions", zoom: "zoom" }, outputs: { selectZoomOptionHandler: "selectZoomOptionHandler" }, decls: 4, vars: 4, consts: [["featureNeededModal", ""], [3, "class", "ngClass", 4, "ngFor", "ngForOf"], [3, "ngClass"], ["href", "javascript:void(0)", "ycnDisabled", "", 3, "click", "disabled", "ngClass"]], template: function FundChartDateZoomComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ul");
        i0.ɵɵtemplate(1, FundChartDateZoomComponent_li_1_Template, 3, 14, "li", 1);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(2, "ycn-feature-needed", null, 0);
    } if (rf & 2) {
        i0.ɵɵclassMapInterpolate1("chart-control ", ctx.customCssClasses.list, "");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.zoomOptions);
    } }, dependencies: [i2.NgClass, i2.NgForOf, i3.DisabledDirective, i4.FeatureNeededComponent], encapsulation: 2 });
